var _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairingDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M11.4 34.4s-.4.8.6 1.8l2.8 2.8c1.6 1.6 2.3.6 3.6-.6 1.3-1.3 2.2-2 .6-3.6L16.2 32c-.9-.9-1.8-.6-1.8-.6M11.3 28.4s.4-.8-.6-1.7l-2.8-2.8c-1.6-1.6-2.3-.6-3.6.6-1.3 1.3-2.2 2-.6 3.6l2.8 2.8c.9.9 1.7.6 1.7.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M8.7 28.7l5.5 5.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M26.2 19.3c-5.8-1.7-5.8 4.4-2.1 4.3 3.6-.1 4 5.7-2.3 4M23.9 18v.5M23.9 28.4v.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 31.5,
    cy: 23.5,
    r: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.5 33.9c3 0 6-.2 8.5-.5 4-.6 4.5-4 4.5-4.7 0-.2.2-3.2-1.3-6.8-2.1-5-6.1-8.9-7.8-10.3-.5-.4-1.1-.7-1.8-.7h-5c-.7 0-1.3.2-1.8.7-1.5 1.3-4.9 4.6-7.1 8.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M20.9 10.9h6c.3 0 .6-.2.8-.5l3.2-5.9c.2-.3.1-.7-.1-1-.5-.5-1.5-1.1-3.2-.5-2.6 1-2.4 1.8-5.6.5-2.2-.9-3.8 0-4.6.7-.3.3-.4.7-.2 1.1l2.9 5.2c.2.2.5.4.8.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairingDeposit);
export default __webpack_public_path__ + "static/media/pairingDeposit.6d41d57ad7e3ad80733a87bbdcc36776.svg";
export { ForwardRef as ReactComponent };